import { render, staticRenderFns } from "./ShippingCompanies.vue?vue&type=template&id=44dc7a52&"
import script from "./ShippingCompanies.vue?vue&type=script&lang=tsx&"
export * from "./ShippingCompanies.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports